module.exports = __webpack_public_path__ + "img/hosteleria-restauracion.8fab86ff.jpg";